import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  BaseButton,
  PrimaryButton,
  rubikTypographyStyles,
} from '../../../shared/ui';

type ValueIntroContinueButtonProps = {
  canSubmit: boolean;
  onContinue: () => void;
};

type ValueIntroSkipButtonProps = {
  isDisabled?: boolean;
  onSkip: () => void;
};

const ContinueButton = styled(PrimaryButton).attrs({
  'data-ui': 'registration-goals-value-intro-continue',
})<{ $isDisabled: boolean }>`
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
`;

const SkipButton = styled(BaseButton).attrs({
  'data-ui': 'registration-goals-value-intro-skip',
})`
  ${rubikTypographyStyles};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 400;
  line-height: 1.25;
  text-decoration: underline;
`;

export function ValueIntroContinueButton({
  canSubmit,
  onContinue,
}: ValueIntroContinueButtonProps) {
  const { t } = useTranslation();

  return (
    <ContinueButton
      $isDisabled={!canSubmit}
      disabled={!canSubmit}
      type="button"
      onClick={onContinue}
    >
      {t('registrationGoalValue.cta')}
    </ContinueButton>
  );
}

export function ValueIntroSkipButton({
  isDisabled = false,
  onSkip,
}: ValueIntroSkipButtonProps) {
  const { t } = useTranslation();

  return (
    <SkipButton disabled={isDisabled} type="button" onClick={onSkip}>
      {t('registrationGoalValue.skip')}
    </SkipButton>
  );
}
